import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiFetch } from '@/lib/api';
import type { Retention } from '@/lib/types';

/**
 * What the system keeps and for how long — a question a customer is entitled to
 * ask and the product answered nowhere.
 */

export function useRetention() {
  return useQuery({
    queryKey: ['retention'],
    queryFn: () => apiFetch<Retention>('/v1/admin/retention'),
    staleTime: 5 * 60 * 1000,
  });
}

export function usePrune() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () =>
      apiFetch<{ deleted: number }>('/v1/admin/retention/prune', { method: 'POST' }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['retention'] }),
  });
}
